// src/auth-attempt-protection-error.schema.ts
import { z } from "zod";
var authAttemptProtectionErrorSchema = z.strictObject({
  error: z.strictObject({
    code: z.number(),
    message: z.string(),
    reasons: z.array(z.unknown()).optional(),
    type: z.string().optional()
  }),
  challenge: z.strictObject({
    type: z.literal("turnstile")
  }).optional()
});

// src/auth-req-body.schema.ts
import { z as z2 } from "zod";
var authReqBodySchema = z2.strictObject({
  data: z2.strictObject({
    identifier: z2.string().trim().min(1),
    bookingNumber: z2.string().trim().min(1),
    challengeToken: z2.string().optional()
  })
});

// src/auth-res-body.schema.ts
import { z as z3 } from "zod";
var authResBodySchema = z3.strictObject({
  data: z3.strictObject({
    auth: z3.boolean(),
    locked: z3.boolean(),
    noActiveContracts: z3.boolean().optional(),
    token: z3.string().optional(),
    challenge: z3.strictObject({
      type: z3.literal("turnstile")
    }).optional()
  })
});

// src/create-payment-intent-res-body.schema.ts
import { z as z4 } from "zod";
var createPaymentIntentResBodySchema = z4.strictObject({
  data: z4.discriminatedUnion("status", [
    z4.strictObject({
      status: z4.literal("ready"),
      clientSecret: z4.string(),
      currency: z4.string(),
      amount: z4.number()
    }),
    z4.strictObject({
      status: z4.literal("no_payments")
    }),
    z4.strictObject({
      status: z4.literal("already_paid")
    }),
    z4.strictObject({
      status: z4.literal("expired")
    }),
    z4.strictObject({
      status: z4.literal("no_active_contracts")
    })
  ])
});
export {
  authAttemptProtectionErrorSchema,
  authReqBodySchema,
  authResBodySchema,
  createPaymentIntentResBodySchema
};
//# sourceMappingURL=index.js.map